import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=746d29bd&scoped=true"
import script from "./PaymentDescription.vue?vue&type=script&lang=ts"
export * from "./PaymentDescription.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&id=746d29bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746d29bd",
  null
  
)

export default component.exports